import styled from "styled-components/macro";
import { device } from "../../../device";

export const StyledErrorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;
  svg {
    display: block;
    width: 100%;
  }
`;

export const StyledErrorTitle = styled.h2`
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;
  color: #575e68;
  @media ${device.mobileL} {
    font-size: 36px;
    line-height: 50px;
  }
`;
export const StyledErrorP = styled.p`
  font-size: 21px;
  line-height: 31px;
  text-align: center;

  color: #575e68;

  @media ${device.mobileL} {
    font-size: 16px;
    line-height: 40px;
  }
`;
